<template>
  <div>
    <!-- 题库中心-最外层容器 -->
    <div
      class="platform-page"
      v-show="$route.name === 'CompetitionCenter-QuestionBankCenter-Platform'"
    >
      <!-- 轮播图 -->
      <div class="swiper">
        <el-carousel
          class="carousel"
          :interval="5000"
          :height="autoHeight"
          indicator-position="none"
        >
          <el-carousel-item v-for="item of bannerList" :key="item.id">
            <el-row>
              <el-col :span="24">
                <div class="wrapper">
                  <el-image class="swiper-img" :src="item.img_url"></el-image>
                </div>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- tab -->
      <div class="platform-tabs">
        <el-tabs
          v-model="tabsObj.value"
          @tab-click="handleClickTabs"
          center
          ref="refTabs"
          :class="tabHeaderIsSticky ? 'isSticky' : ''"
          :style="{ '--width': `calc(100vw - ${scrollbarWidth}px)` }"
        >
          <el-tab-pane
            v-for="item in tabsObj.list"
            :key="item.value"
            :label="item.label"
            :name="item.value"
          >
            <template v-if="item.value === '1'">
              <subunitCard
                :sourceList="matchSourceList"
                v-if="matchSourceList.join('') !== ''"
              />
              <!-- <div class="title" v-if="matchSourceList.join('') !== ''">
                大赛
              </div>
              <subunitCard
                :sourceList="matchSourceList"
                v-if="matchSourceList.join('') !== ''"
              />
              <div class="title" v-if="levelMatchSourceList.join('') !== ''">
                考级
              </div>
              <subunitCard
                :sourceList="levelMatchSourceList"
                v-if="levelMatchSourceList.join('') !== ''"
              /> -->
            </template>
            <template v-if="item.value === '2'">
              <formative-test
                :sourceList="sourceList"
                v-if="sourceList.join('') !== '' && tabsObj.value === '2'"
              />
            </template>
            <template v-if="item.value === '3'">
              <div class="pane3" v-if="tabsObj.value === '3'">
                <div class="filters">
                  <div class="filter-left">
                    <div class="filter-left-fixed">
                      <svg
                        t="1714119505513"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2719"
                        width="25"
                        height="25"
                      >
                        <path
                          d="M141.3 420.1V188.8l231.2-0.1 0.1 231.3-231.3 0.1z m231.3-308.4H141.2c-42.5 0.1-76.9 34.5-77 77v231.5c0.1 42.5 34.5 76.9 77 77h231.5c42.5-0.1 76.9-34.5 77-77V188.7c-0.2-42.5-34.6-76.9-77.1-77zM141.3 882.6V651.2l231.2-0.1 0.1 231.3-231.3 0.2z m231.3-308.4H141.2c-42.5 0.1-76.9 34.5-77 77v231.5c0.1 42.5 34.5 76.9 77 77h231.5c42.5-0.1 76.9-34.5 77-77V651.1c-0.2-42.4-34.6-76.8-77.1-76.9zM719.4 468L555.8 304.4l163.4-163.6 163.7 163.5L719.4 468z m218-218L773.7 86.4c-30.1-30-78.7-30-108.8 0L501.3 250a76.744 76.744 0 0 0-22.5 54.3c-0.1 20.5 8 40.1 22.5 54.6L665 522.6c30.1 30 78.8 30 108.8 0l163.7-163.7c29.9-30.2 29.9-78.9-0.1-108.9zM603.7 882.6V651.2l231.2-0.1 0.1 231.3-231.3 0.2z m231.4-308.4H603.6c-42.5 0.1-76.9 34.5-77 77v231.5c0.1 42.5 34.5 76.9 77 77h231.5c42.5-0.1 76.9-34.5 77-77V651.1c-0.1-42.4-34.6-76.8-77-76.9z"
                          p-id="2720"
                          fill="#000000"
                        ></path>
                      </svg>
                      <span>分类</span>
                    </div>
                    <div class="filter-tabs">
                      <div
                        :class="{
                          'filter-tab': 1,
                          active: practiceTabs.value === practiceTab.id,
                        }"
                        v-for="practiceTab in practiceTabs.list"
                        :key="practiceTab.id"
                        @click="handleClickPracticeTabs(practiceTab.id)"
                      >
                        {{ practiceTab.title }}
                      </div>
                    </div>
                  </div>
                  <div class="filter-right">
                    <el-select
                      v-model="form1.subject_id"
                      placeholder="请选择科目"
                      clearable
                      @change="search"
                      size="small"
                    >
                      <el-option
                        :label="item.name"
                        :value="item.id"
                        v-for="(item, index) of subjectList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="content">
                  <!-- <div class="jump-video">
                    <el-button type="primary" plain @click="goLookVideo"
                      >查看相关视频</el-button
                    >
                  </div> -->
                  <div class="table">
                    <el-table
                      size="small"
                      :data="questionlist"
                      :header-cell-style="{
                        background: '#f5f7fa',
                        color: '#606266',
                        'font-size': '14px',
                      }"
                      stripe
                    >
                      <el-table-column
                        type="index"
                        align="center"
                        width="50"
                        label="序号"
                      >
                        <template slot-scope="scope">
                          <span>{{
                            scope.$index + 1 + (page_no - 1) * page_size
                          }}</span>
                        </template>
                      </el-table-column>

                      <el-table-column
                        align="left"
                        label="科目"
                        prop="subjectName"
                        width="80"
                      >
                      </el-table-column>

                      <el-table-column
                        align="left"
                        label="题库名称"
                        prop="title"
                      >
                      </el-table-column>
                      <el-table-column
                        align="left"
                        label="来源"
                        prop=""
                        width="150"
                      >
                        <template slot-scope="scope">
                          <span v-if="scope.row.sourceInfo != null">{{
                            scope.row.sourceInfo.title
                          }}</span>
                          <span v-else>--</span>
                        </template>
                      </el-table-column>

                      <el-table-column
                        align="left"
                        label="简介"
                        prop="content"
                        width="250"
                      >
                      </el-table-column>

                      <el-table-column
                        align="center"
                        label="题数"
                        prop="question_num"
                        width="100"
                      >
                      </el-table-column>

                      <el-table-column align="center" label="操作" width="100">
                        <template slot-scope="scope">
                          <el-button
                            @click="QuestionManagement1(scope.row)"
                            type="text"
                            size="mini"
                            class="wg-table-operation"
                            >题库预览</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="pagination">
                      <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page_no"
                        background
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="page_size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                      >
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import formativeTest from './formativeTest.vue'
import subunitCard from '../subunitComponents/subunitCard.vue'

import {
  api_getSchoolBannerList,
  api_getBankSourceListWithoutPageForNew,
  api_getTestQuestionBankSourceTagListWithoutPage,
} from '@/api/competitionCenter'

import { getEleRectTop, getScrollbarWidth } from '@/utils/utils'

import {
  addOrUpdateSchoolQuestionBank,
  getSchoolQuestionBankList,
  deleteSchoolQuestionBank,
  changeSchoolQuestionBankPostState,
  getTestQuestionBankSourceListWithoutP,
} from '@/api/educational'

import { getZoneSchoolSubjectList } from '@/api/community'

import uploadFile from '@/config/uploadFile'

export default {
  name: 'CompetitionCenter-QuestionBankCenter-Platform',
  components: {
    formativeTest,
    subunitCard,
  },
  data() {
    return {
      bannerList: [], //社区轮播图
      tabsObj: {
        value: '1',
        list: [
          { label: '赛考训练', value: '1' },
          { label: '阶段测评', value: '2' },
          { label: '金牌师训', value: '3' },
        ],
      },
      tabHeaderIsSticky: false,

      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,
      dialogFormVisible: false,
      dialogFormVisible1: false,

      autoHeight: '0px', //轮播图自适应高度
      dialogVisible: false,
      project_url: '',

      sourceList: [], // tab查询来源列表 来源类型 1赛考训练 2阶段测评 3金牌师训 注意1类型和其他类型返回的结构不一样，需要分别处理
      matchSourceList: [], // 1赛考训练的大赛列表
      // levelMatchSourceList: [], // 1赛考训练的考级列表

      practiceTabs: {
        // 真题练习分类
        value: '',
        list: [
          { title: '全部', id: '' },
          // { label: 'NCT 图形化 1级', value: 1 },
          // { label: 'NCT 图形化 2级', value: 2 },
          // { label: 'NCT C++ 1级', value: 3 },
          // { label: 'NCT C++ 2级', value: 4 },
          // { label: 'NCT C++ 3级', value: 5 },
          // { label: 'NCT C++ 4级', value: 6 },
        ],
      },
      selectSubject: '', // 选择科目
      yearSelection: '', // 年份选择
      tableTitle: [
        { label: '日期', value: 'date' },
        { label: '姓名', value: 'name' },
        { label: '省份', value: 'province' },
        { label: '城市', value: 'city' },
        { label: '地址', value: 'address' },
        { label: '邮编', value: 'zip' },
        { label: '地址分类', value: 'tag' },
      ],
      tableData: [],
      options: [],
      subject_state: 1,
      uploadFileTime: false,
      questionlist: [],

      form: {
        id: '',
        sort_num: 1,
        title: '',
        subject_id: '',
        desc: '',
        img_url: '',
        imgList: [],
      },

      form1: {
        subject_id: '',
        title: '',
        source_id: '',
      },

      subjectList: [],
      input: '',
      page_no: 1,
      page_size: 10,
      total: 0,
      scrollbarWidth: getScrollbarWidth(),
    }
  },
  mounted() {
    this.getAutoHeight()
    this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50
    this.frameHeight = this.frameWidth * 0.75 + 55
    this.frameWidth1 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight1 = this.frameWidth1 * 0.5 + 55
    this.scale = this.frameWidth / 480

    //刷新完token调接口
    this.getSchoolBannerList()

    if (this.$store.state.user.token) {
      this.freshData()
    }
    if (this.$refs.refTabs) {
      // 监听滚动事件
      window.addEventListener('scroll', this.handleGetElemRectTop)
    }

    const questionBankCenterPlatformTabVal = window.sessionStorage.getItem(
      'questionBankCenterPlatformTabVal'
    )
    if (questionBankCenterPlatformTabVal) {
      this.tabsObj.value = questionBankCenterPlatformTabVal
    }
    this.handleClickTabs()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleGetElemRectTop)
  },
  methods: {
    async handleClickTabs() {
      window.sessionStorage.setItem(
        'questionBankCenterPlatformTabVal',
        this.tabsObj.value
      )
      await this.methodSearch()
      if (this.tabsObj.value === '3') {
        this.getZoneSchoolSubjectList()
        this.getSchoolQuestionBankList()
        this.getTestQuestionBankSourceTagListWithoutPage()
        this.getTestQuestionBankSourceListWithoutP()
      }
    },
    /**获取元素距离可视区域距离是否为0 */
    handleGetElemRectTop() {
      const stickyElem = this.$refs.refTabs.$el.children[0]
      this.tabHeaderIsSticky = getEleRectTop(stickyElem)
    },
    //刷新账号信息
    freshData() {
      this.$store.dispatch('freshUserData')
    },

    //轮播图自适应高度
    getAutoHeight() {
      let _w = document.documentElement.clientWidth || document.body.clientWidth
      let _h = _w * 0.196
      this.autoHeight = (_h > 300 ? 300 : _h) + 'px'
    },
    //获得社区轮播图
    getSchoolBannerList() {
      api_getSchoolBannerList({
        banner_type: 2,
      }).then((res) => {
        console.log('获取校区轮播图')
        console.log(res)
        this.bannerList = res.bannerList
      })
    },
    async methodSearch() {
      await this.getBankSourceListWithoutPageForNew()
    },
    async getBankSourceListWithoutPageForNew() {
      if (this.tabsObj.value === '2') this.sourceList = []
      const res = await api_getBankSourceListWithoutPageForNew({
        source_type: this.tabsObj.value,
      })
      console.log(res.sourceList)
      if (res) {
        if (
          Object.prototype.toString.call(res.sourceList) === '[object Object]'
        ) {
          // this.matchSourceList = res.sourceList.matchSourceList
          // this.levelMatchSourceList = res.sourceList.levelMatchSourceList
          // this.sourceList = [
          //   ...res.sourceList.matchSourceList,
          //   ...res.sourceList.levelMatchSourceList,
          // ]
          this.matchSourceList = [
            ...res.sourceList.matchSourceList,
            ...res.sourceList.levelMatchSourceList,
          ]
        } else {
          res.sourceList.forEach((sourceItem) => {
            sourceItem.id = String(sourceItem.id)
          })
          this.sourceList = res.sourceList
        }
      }
    },

    //来源列表
    getTestQuestionBankSourceListWithoutP() {
      getTestQuestionBankSourceListWithoutP().then((res) => {
        console.log(res, 95656)
        this.options = res.testQuestionBankSourceList
      })
    },
    async getTestQuestionBankSourceTagListWithoutPage() {
      const res = await api_getTestQuestionBankSourceTagListWithoutPage({
        source_id: this.sourceList[0].id, // 题库来源
      })
      console.log(res)
      if (res && res.testQuestionBankSourceTagList) {
        this.practiceTabs.list = [
          { id: '', title: '全部' },
          ...res.testQuestionBankSourceTagList,
        ]
      }
    },
    //添加题库
    addOrUpdateSchoolQuestionBank() {
      if (this.form.id) {
        this.dialog_title = '修改题库'
        addOrUpdateSchoolQuestionBank({
          questionBankId: this.form.id,
          subject_id: this.form.subject_id,
          title: this.form.title,
          content: this.form.desc,
          sort_num: this.form.sort_num,
          cover_url: this.form.imgList[0].url,
        }).then((res) => {
          console.log('更新成功')
          console.log(res)
          if (res.is_update) {
            this.$message.success('更新成功')
            this.dialogVisible = false
            this.getSchoolQuestionBankList()
          }
        })
      } else {
        this.dialog_title = '新增题库'
        addOrUpdateSchoolQuestionBank({
          subject_id: this.form.subject_id,
          title: this.form.title,
          content: this.form.desc,
          sort_num: this.form.sort_num,
          cover_url: this.form.imgList[0].url,
        }).then((res) => {
          console.log('添加题库')
          console.log(res)
          if (res.is_created) {
            this.$message.success('添加成功')
            this.dialogVisible = false
            this.getSchoolQuestionBankList()
            this.form = {}
          }
        })
      }
    },
    search() {
      this.page_no = 1
      this.getSchoolQuestionBankList()
    },

    //查询题库
    getSchoolQuestionBankList() {
      getSchoolQuestionBankList({
        // source_id: this.form1.source_id,
        source_id: this.sourceList[0].id,
        subject_id: this.form1.subject_id,
        title: this.form1.title,
        search_question_bank_type: '1',
        post_state: '',
        page_no: this.page_no,
        page_size: this.page_size,
        source_tag_id: this.practiceTabs.value,
      }).then((res) => {
        console.log('查询校区题库')
        console.log(res)
        this.questionlist = res.questionBankList
        this.total = res.total
      })
    },

    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList().then((res) => {
        console.log('校区科目')
        console.log(res)
        this.subjectList = res.subjectList
      })
    },

    //编辑题库
    QuestionBank(row) {
      console.log('编辑题库')
      console.log(row)
      this.dialogVisible = true
      this.form.id = row.id
      this.form.sort_num = row.sort_num
      this.form.subject_id = row.subject_id
      this.form.title = row.title
      this.form.desc = row.content
      this.form.imgList = [
        {
          url: row.cover_url,
          name: row.cover_url.split('/')[row.cover_url.split('/').length - 1],
        },
      ]
    },

    deleteSchoolQuestionBank(id) {
      this.$confirm('确定删除该题库吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteSchoolQuestionBank({
          questionBankId: id,
        }).then((res) => {
          console.log('删除题库')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.getSchoolQuestionBankList()
          }
        })
      })
    },
    //发布状态
    changeSchoolQuestionBankPostState(id, cmd) {
      changeSchoolQuestionBankPostState({
        questionBankId: id,
        post_state: cmd,
      }).then((res) => {
        console.log('题库发布状态')
        console.log(res)

        this.getSchoolQuestionBankList()
      })
    },

    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.form.imgList = res
          this.uploadFileTime = false
        }
      )
    },

    //添加试题
    AddQuestion(row) {
      console.log('添加试题')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-AddQuestion',
        query: {
          id: row.id,
          title: row.title,
          subject_id: row.subject_id,
        },
      })
    },
    QuestionManagement(row) {
      console.log('试题管理')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-PlatformQuestionlist',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    QuestionManagement1(row) {
      console.log('试题管理')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-PlatformQuestionlist1',
        query: {
          id: row.id,
          title: row.title,
          subject_id: row.subject_id,
        },
      })
    },
    Practice(row) {
      console.log('练习')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Practice',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getSchoolQuestionBankList()
    },
    handleSizeChange(val) {
      this.page_no = 1
      this.page_size = val
      this.getSchoolQuestionBankList()
    },
    handleRemove() {},
    uploadFile() {},
    goLookVideo() {
      let routeData = this.$router.resolve({
        name: 'trainingForTeachers',
        query: {
          // subject_id: 2,
          title: '金牌师训',
        },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.platform-page {
  padding: 10px;
  .carousel {
    max-width: 1680px;
    margin: auto;

    /deep/ .el-carousel__container {
      .el-carousel__item {
        height: 100%;

        .el-row {
          height: 100%;

          .el-col {
            height: 100%;

            .wrapper {
              height: 100%;

              .el-image {
                height: 100%;
              }
            }
          }
        }
      }

      .el-carousel__arrow {
        display: none;
        width: 3vw;
        height: 3vw;
        font-size: 28px;
        font-weight: bold;

        &:hover {
          color: #fff304;
        }
      }
    }

    .wrapper {
      width: 100%;
      // height: 0;
      // padding-bottom: 29.6%;

      .swiper-img {
        width: 100%;
        border-radius: 10px;
      }
    }
  }

  .platform-tabs /deep/ {
    .el-tabs {
      &.isSticky {
        .el-tabs__header {
          background-color: #fff;
          max-width: initial;
          .el-tabs__nav-wrap {
            background: #fff;
          }
        }
      }
      .el-tabs__nav-scroll {
        display: flex;
        justify-content: center;
      }

      .el-tabs__header {
        position: sticky;
        top: 0;
        z-index: 9;
        max-width: 1680px;
        margin: auto;
        .el-tabs__nav-wrap {
          min-width: 900px;
          // width: calc(100vw - 17px);
          // width: 100vw;
          width: var(--width);
          transform: translateX(-50%);
          left: 50%;
        }
        .el-tabs__nav-wrap::after {
          height: 1px !important;
          background-color: #e6e6e6 !important;
        }

        .el-tabs__item {
          height: 55px;
          line-height: 55px;
          font-size: 16px;
          font-weight: 400;

          &.is-active {
            font-weight: 600;
          }
        }
      }

      .el-tabs__content {
        max-width: 1680px;
        // padding: 0px 50px;
        margin: auto;
        #pane-1 > .title {
          display: flex;
          align-items: center;
          width: 100%;
          height: 55px;
          font-weight: 400;
          font-size: 16px;
          color: #1678ff;
        }
        #pane-2,
        #pane-3 {
          padding-top: 20px;
        }
        .pane3 {
          .filters {
            display: flex;
            justify-content: space-between;
            padding: 20px 20px 10px;
            background-color: #fff;
            border-radius: 20px;
            zoom: 1;
            margin-bottom: 20px;
            font-size: 14px;
            color: #333;
            // &:after {
            //   content: '';
            //   display: table;
            //   clear: both;
            // }
            .filter-left {
              display: flex;
              .filter-left-fixed {
                flex-shrink: 0;
                display: flex;
                align-items: center;
                height: 50px;
                .icon {
                  margin-bottom: 10px;
                }
                span {
                  padding: 0 20px 10px;
                }
              }
              .filter-tabs {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .filter-tab {
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  min-width: 88px;
                  height: 40px;
                  padding: 0 20px;
                  margin-right: 15px;
                  margin-bottom: 10px;
                  border-radius: 20px;
                  background-color: #f6f6f6;
                  transition: color 0.2s, background-color 0.2s, opacity 0.2s;

                  cursor: pointer;
                  &:hover,
                  &.active {
                    color: #fff;
                    background-color: #1678ff;
                  }
                  &:active {
                    opacity: 0.9;
                  }
                }
              }
            }
            .filter-right {
              display: flex;
              align-items: flex-start;
              padding-top: 4px;
            }
          }
          .content {
            padding: 30px 30px 80px;
            background-color: #fff;
            border-radius: 20px;
            .jump-video {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              padding-bottom: 20px;
            }
            .table {
              .pagination {
                padding-top: 20px;
                text-align: right;
              }
            }
          }
        }
      }
    }
  }
}
</style>
